import React from 'react'

import {
  AlignItems,
  Body2,
  Bold,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  Image,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { Carousel, LandingPageButton } from '../../../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { MealPlanningSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import { MENU_CAROUSEL } from './config'

export type SlideType = {
  src: string
  alt: string
  startOnboarding: (target: TargetUri) => void
  sectionName: MealPlanningSections
  target: TargetUri
  action: TrackingActions
  ctaText: string
  subtitle: string
  title: string
}

function Slide({
  startOnboarding,
  src,
  alt,
  sectionName,
  target,
  action,
  ctaText,
  subtitle,
  title,
}: SlideType) {
  return (
    <>
      <Box
        paddingBottom={3}
        width={['100%', '240px']}
        height={['auto', '100%']}
        display={Display.Flex}
        paddingH={2}
        paddingV={3}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        bg={Color.White}
        style={{ borderRadius: '4px' }}
      >
        <Image
          style={{ borderRadius: '4px' }}
          height={['auto', '200px']}
          width={['100%', '216px']}
          fit="cover"
          src={src}
          alt={alt}
        />
        <Box
          paddingH={2}
          paddingV={2}
          flexGrow={1}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.SpaceBetween}
        >
          <Box>
            <Body2 size={4}>
              <Bold>{title}</Bold>
            </Body2>
            <Body2 size={4}>{subtitle}</Body2>
          </Box>
          <Space size={2} />
          <Box>
            <LandingPageButton
              startOnboarding={startOnboarding}
              sectionName={sectionName}
              target={target}
              action={action}
              asLink
            >
              <Body2 size={4} color={Color.Secondary_400}>
                <Bold>{ctaText}</Bold>
              </Body2>
            </LandingPageButton>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export function MenuCarousel({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box bg={Color.NeutralGrey_50} paddingH={4} paddingV={[4, 8]}>
      <Box>
        <Box paddingH={[4, 0]}>
          <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>
            {MENU_CAROUSEL.heading}
          </Heading2>
          <Space size={2} />
          <Body2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]} size={4}>
            {MENU_CAROUSEL.subtitle}
          </Body2>
        </Box>

        <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
          <Carousel carouselAreaLabel="Menu Carousel" options={{ loop: true }}>
            {MENU_CAROUSEL.categories.map((slide) => {
              return <Slide key={slide.id} startOnboarding={startOnboarding} {...slide} />
            })}
          </Carousel>
        </Box>
      </Box>
    </Box>
  )
}
